// 极速预约
const specialDisease = [
  {
    path: '/special-disease/home',
    name: '极速预约',
    component: () => import('@/pages/special-disease/SearchHome.vue')
  },
  {
    path: '/special-disease/search-result',
    'name': '极速预约',
    component: () => import('@/pages/special-disease/SearchResult.vue')
  },
  {
    path: '/special-disease/search/:type',
    name: '极速预约',
    component: () => import('@/pages/special-disease/SearchFullList.vue')
  },
  {
    path: '/special-disease/search-history',
    name: '极速预约',
    component: () => import('@/pages/special-disease/SearchHistory.vue')
  },
  {
    path: '/zone/:id',
    name: '极速预约',
    component: () => import('@/pages/special-disease/ZoneDetail.vue')
  }
]

export default specialDisease
